import { useCallback, useState, useEffect } from 'react';
import { Logger } from '../utils';

export default function useDeviceSettingsToggle() {
    const [deviceSettingsOpen, setDeviceSettingsOpen] = useState(false);

    useEffect(() => {
        Logger(`UI.Twilio.Room.DeviceSettings.${deviceSettingsOpen ? "Opened" : "Closed"}`, new Date());
    }, [deviceSettingsOpen]);

    const toggleDeviceSettings = useCallback((value) => {
        if (value === false || value === true) {
            setDeviceSettingsOpen(value);
        } else {
            setDeviceSettingsOpen(deviceSettingsOpen => !deviceSettingsOpen);
        }
    }, [deviceSettingsOpen]);

    return [deviceSettingsOpen, toggleDeviceSettings];
}
